var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audience-associated-campaigns-grid',{attrs:{"audienceId":_vm.AudienceId}})}
var staticRenderFns = []

export { render, staticRenderFns }